import {
  ButtonBase,
  ButtonBaseProps,
  styled,
  Typography,
  TypographyProps,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import ChevronRight from '@mui/icons-material/ChevronRight';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';
import Row from '../Layout/Row';

const StyledButtonBase = styled(ButtonBase)<{
  ownerState: { textDecoration: 'underline' | 'none' };
}>(({ ownerState }) => ({
  font: 'inherit',
  verticalAlign: 'baseline',
  textDecoration: ownerState.textDecoration,
  color: blue[500],
  '& .MuiSvgIcon-root': {
    color: blue[500],
  },
  '&.Mui-focusVisible': {
    outline: `2px solid ${blue[500]}`,
    outlineOffset: '1px',
    borderRadius: '2px',
  },
}));

type Props = Omit<ButtonBaseProps, 'variant'> & {
  text: string;
  to?: string;
  href?: string;
  textDecoration?: 'underline' | 'none';
  showExpandableStartAdornment?: boolean;
  isExpanded?: boolean;
  variant?: TypographyProps['variant'];
};

const TypographyButton: React.FC<Props> = ({
  text,
  textDecoration = 'underline',
  showExpandableStartAdornment = false,
  isExpanded,
  variant = 'inherit',
  ...props
}) => {
  return (
    <Typography variant={variant} display="inline">
      <StyledButtonBase ownerState={{ textDecoration }} {...props}>
        <Row centered>
          {showExpandableStartAdornment ? (
            isExpanded ? (
              <KeyboardArrowDown fontSize="small" />
            ) : (
              <ChevronRight fontSize="small" />
            )
          ) : null}
          {text}
        </Row>
      </StyledButtonBase>
    </Typography>
  );
};

export default TypographyButton;
